export function getNewsListPath(slug: string) {
  return `/data/${slug}/news.json`;
}

export function getNewsDetailPath(slug: string, id: string) {
  return `/data/${slug}/news/${encodeURIComponent(id)}.json`;
}

export function getGoodsPath(slug: string) {
  return `/data/${slug}/goods.json`;
}

export function getCtaListPath(slug: string) {
  return `/data/${slug}/cta.json`;
}
